import styled from 'styled-components';
import { color } from 'styles/colors';

export const container: any = styled.div`
  width: fit-content;
  max-height: 40px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border: 1px solid ${color.interface.lightBlue3};
  border-radius: 10px;
  cursor: pointer;

  > svg,
  p {
    color: ${color.interface.lightBlue3};
  }

  > svg {
    font-size: 1.5rem;
  }

  > p {
    font-size: 1rem;
    font-weight: 600;
  }
`;
